import { render, staticRenderFns } from "./CredentialsSettings.vue?vue&type=template&id=2fd58326&scoped=true&"
import script from "./CredentialsSettings.vue?vue&type=script&lang=js&"
export * from "./CredentialsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsSettings.vue?vue&type=style&index=0&id=2fd58326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd58326",
  null
  
)

export default component.exports